import { motion } from 'framer-motion';
import { useRef, useState } from 'react';
import { NavLink } from 'react-router-dom';
const OurWork = () => {
  const [activeFilter, setActiveFilter] = useState('*');

  const containerRef = useRef(null);

  const projects = [
    {
      id: 2,
      title: 'AI Virtual Assistance',
      categories: ['ai-virtual-assistance'],
      image: 'img/mine/AI chatbot.png',
      link: '/chatbotbase',
      description:
        'Enhance your business with AI-powered virtual assistance. Our chatbot provides real-time support, automates responses, and improves customer engagement. Experience seamless and intelligent communication with our advanced AI solution.'
    },
    {
      id: 3,
      title: 'Job Description Generator',
      categories: ['job-description-generator'],
      image: 'img/mine/Job dicrption genrator.png',
      link: '/jobdescription/jobdescriptionUtility',
      description:
        'Crafts precise and tailored job descriptions effortlessly, ensuring that the job requirements and responsibilities are clearly defined to attract the right candidates.'
    },
    {
      id: 4,
      title: 'Tech Stack Predictor',
      categories: ['tech-stack-predictor'],
      image: 'img/mine/Tech Stack Predictor.png',
      link: '/techpred/home',
      description:
        'Suggests optimal technology stacks for projects based on specific requirements, industry standards, and project complexity to maximize performance and scalability.'
    },
    {
      id: 5,
      title: 'Prescription Detector',
      categories: ['prescription-detector'],
      image: 'img/mine/robot-working-pharmaceutical-field-instead-humans.jpg',
      link: '/prescription/prescriptionUtility',
      description:
        'Leverage AI to extract medication names, dosages, and instructions from handwritten or printed prescriptions—optimized for healthcare accuracy, efficiency, and scalability.'
    },
    {
      id: 6,
      title: 'LinkedIn Post Assistant',
      categories: ['linkedin-post'],
      image: 'img/mine/Linkedinpost.jpg',
      link: '/linkedinpost',
      description:
        'Not sure what to post on LinkedIn? Let AI help you out! Create thoughtful, attention-grabbing posts in no time — perfect for busy professionals like you.'
    },
    {
      id: 7,
      title: 'Recommendation Engine',
      categories: ['recommendation-engine'],
      image: 'img/mine/recommendationEngine.jpg',
      link: '/recommendation/recommendationUtility',
      description:
        'Our AI delivers personalized toy suggestions in seconds, based on your child’s unique interests and preferences. Just answer a few simple questions—our system matches your input with the best-fit toys, making discovery fun, fast, and effortless'
    },
   {
      id: 8,
      title: 'Lesson Planner',
      categories: ['lesson-planner'],
      image: 'img/mine/lessonplanner.jpg',
      link: '/lessonplanner',
      description:
        'Lesson Planner AI helps educators quickly generate customized lesson plans by inputting topic, grade, board, and teaching preferences. It streamlines planning and ensures content is tailored for concept clarity, activities, or assessments—enhancing classroom effectiveness.'
    },
    {
      id: 9,
      title: 'Smart AI Virtual Assistance',
      categories: ['crawling-chatbot'],
      image: 'img/mine/crawling_chatbot.jpg',
      link: '/crawling/crawlingChatbotUtility',
      description:
        'Build a smart AI-powered chatbot trained directly from your website’s content. Just enter a URL — our system automatically crawls the site, extracts text, creates a knowledge base, and generates a chatbot you can embed anywhere.'
    }
  ];

  const categories = [
    { label: 'View All', value: '*' },

    { label: 'AI Virtual Assistance', value: 'ai-virtual-assistance' },
    { label: 'Job Description + AI', value: 'job-description-generator' },
    { label: 'Pick My Stack', value: 'tech-stack-predictor' },
    { label: 'Prescription Detector', value: 'prescription-detector' },
    { label: 'Linkedin Post Assistant', value: 'linkedin-post'},
    { label: 'Recommendation Engine', value: 'recommendation-engine'},
    { label: 'Lesson Planner', value: 'lesson-planner' },
    { label: 'Smart AI Virtual Assistance', value: 'crawling-chatbot' },
  ];
  const filteredProjects = activeFilter === '*' ? projects : projects.filter((project) => project.categories.includes(activeFilter));

  const handleFilterClick = (value) => {
    setActiveFilter(value);
    containerRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <div role="main" className="main">
      <section
        className="page-header page-header-modern page-header-background bg-color-dark p-relative z-index-1"
        style={{
          backgroundImage: `url('img/mine/OurUtilities.png')`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat'
        }}
      >
        <motion.span
          className="custom-circle custom-circle-1 bg-color-light custom-circle-blur"
          initial={{ x: -50, opacity: 0 }}
          whileInView={{ x: 0, opacity: 1 }}
          transition={{ delay: 0.4, duration: 0.5 }}
          viewport={{ once: true }}
        ></motion.span>

        <motion.span
          className="custom-circle custom-circle-2 bg-color-primary"
          initial={{ scale: 0 }}
          whileInView={{ scale: 1 }}
          transition={{ delay: 0.5, duration: 0.5 }}
          viewport={{ once: true }}
        ></motion.span>

        <motion.span
          className="custom-circle custom-circle-3 bg-color-primary"
          initial={{ scale: 0 }}
          whileInView={{ scale: 1 }}
          transition={{ delay: 0.6, duration: 0.5 }}
          viewport={{ once: true }}
        ></motion.span>

        {/* Content */}
        <div className="container">
          <div className="row mt-5">
            <div className="col">
              <ul className="breadcrumb breadcrumb-light custom-title-with-icon-primary d-block">
                <li>
                  <NavLink to="/">Home</NavLink>
                </li>
                <li className="active">Our Utilities</li>
              </ul>
              <h1 className="custom-text-10 font-weight-bold">Our Utilities</h1>
            </div>
          </div>
        </div>
      </section>
      <section className="py-5">
        <div className="container sticky-container mt-xl-3">
          <div className="row justify-content-between">
            <div className="col-xl-3 position-relative" ref={containerRef}>
              <div
                className="side-menu-our-work sidebar mb-5"
                style={{
                  position: 'sticky',
                  top: '150px',
                  maxHeight: `calc(100vh - 150px)`,
                  overflowY: 'auto'
                }}
              >
                <h4 className="text-color-dark font-weight-bold">Filter by Category:</h4>
                <ul className="list-unstyled">
                  {categories.map((category) => (
                    <li key={category.value} className={`nav-item `}>
                      <div
                        onClick={() => handleFilterClick(category.value)}
                        className="text-color-hover-dark text-decoration-none mb-2 p-0 d-block hover-bold"
                        style={{
                          cursor: 'pointer',
                          color: 'black',
                          fontWeight: activeFilter === category.value ? 'bold' : 'normal'
                        }}
                      >
                        {category.label}
                      </div>
                    </li>
                  ))}
                </ul>
              </div>
            </div>

            <div className="col-xl-8 our-work" id="ourWork">
              <div className="sort-destination w-100">
                {filteredProjects.map((project) => (
                  <div key={project.id} className="row w-100 mb-4">
                    <div className="col-sm-12 custom-our-work overlay overlay-op-9 overlay-show p-0">
                      <NavLink to={project.link} className="d-block h-100">
                        <img src={project.image} alt={project.title} className="w-100 h-100" />
                        <div className="w-100 custom-our-work-text px-5 py-3 d-flex align-items-end position-absolute bottom-0">
                          <div className="text-start position-relative z-index-2 mb-3">
                            <h1 className="text-color-light font-weight-bold mb-2">{project.title}</h1>
                            <p className="text-uppercase text-color-quaternary mb-3">{project.categories.join(', ')}</p>
                            <span className="custom-text-4 font-weight-semibold m-0 p-0 text-color-light">View Work</span>
                          </div>
                        </div>
                      </NavLink>
                    </div>
                  </div>
                ))}
                {filteredProjects.length === 0 && <p className="text-center">No projects found</p>}
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default OurWork;
